<template>
  <!--begin::Header-->
  <div>
    <div id="kt_app_header" class="app-header" v-if="authenticated">
      <!--begin::Header container-->
      <div class="app-container container-fluid d-flex align-items-stretch justify-content-between" id="kt_app_header_container">
        <!--begin::sidebar mobile toggle-->
        <div class="d-flex align-items-center d-lg-none ms-n2 me-2" title="Show sidebar menu">
          <div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
            <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
            <span class="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z" fill="currentColor" />
                <path opacity="0.3" d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z" fill="currentColor" />
              </svg>
            </span>
            <!--end::Svg Icon-->
          </div>
        </div>
        <!--end::sidebar mobile toggle-->
        <!--begin::Mobile logo-->
        <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
          <router-link to="/" class="d-lg-none">
            <img alt="Logo" src="/images/layout/logo-pixel-principal.png" class="h-35px" />
          </router-link>
        </div>
        <!--end::Mobile logo-->
        <!--begin::Header wrapper-->
        <div class="d-flex align-items-stretch justify-content-between flex-lg-grow-1" id="kt_app_header_wrapper">
          <!--begin::Menu wrapper-->
          <div class="app-header-menu app-header-mobile-drawer align-items-stretch" data-kt-drawer="true" data-kt-drawer-name="app-header-menu" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="250px" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_app_header_menu_toggle" data-kt-swapper="true" data-kt-swapper-mode="{default: 'append', lg: 'prepend'}" data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}">
          </div>
          <!--end::Menu wrapper-->
          <!--begin::Navbar-->
          <div class="app-navbar flex-shrink-0 gap-5">
            <div class="app-navbar-item ms-2" v-if="1 == 2">
              <button class="chat-button" id="kt_drawer_chat_ia_button" @click="handleOpenChat">
                <img src="/images/v2/layout/pixel-intelligence-icone.png" width="15" alt="" class="me-md-2"> <span class="d-none d-md-inline-block">Pixel Intelligence</span>
              </button>
            </div>

            <div class="app-navbar-item ms-2 d-none d-sm-flex">
              <router-link
                class="menu-link"
                :class="{ active: $route.name === 'users.settings.show' }"
                :to="{ name: 'users.settings.show' }">
                <BaseIcon size="xxSmall">
                  <UserIcon />
                </BaseIcon>
                <span class="ms-3">{{ $t('my_account') }}</span>
              </router-link>
            </div>

            <!--begin::Header menu toggle-->
            <div class="app-navbar-item ms-2">
              <select v-model="$i18n.locale" class="form-select border-0 font-size-small" @change="changeLanguage">
                <option value="pt_BR">PT</option>
                <option value="en">EN</option>
                <option value="es">ES</option>
              </select>
            </div>
            <!--end::Header menu toggle-->

            <!--begin::Theme mode-->
            <!-- <div class="app-navbar-item ms-1 ms-lg-3">
              <ThemeModeSwitcher />
            </div> -->
            <!--end::Theme mode-->

            <!--begin::Header menu toggle-->
            <div class="app-navbar-item ms-2 d-none d-sm-flex">
              <a href="javascript:void(0);" @click.prevent="logout" class="link-color2">
                {{ $t('logout') }}
              </a>
            </div>
            <!--end::Header menu toggle-->
          </div>
          <!--end::Navbar-->
        </div>
        <!--end::Header wrapper-->
      </div>
      <!--end::Header container-->
    </div>
    <div v-else>
      <div class="header py-5 px-20 bg-white">
        <router-link to="/">
          <img alt="Logo" src="/images/layout/logo-pixel-principal.png" class="h-35px" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import UsersService from '@/modules/users/services/users-service'
import { mapState, mapActions } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import UserIcon from '@/components/common/Icon/UserIcon'
// import ThemeModeSwitcher from '@/v2/components/headers/ThemeModeSwitcher'

export default {
  name: 'TheHeader',
  components: {
    BaseIcon,
    UserIcon
    // ThemeModeSwitcher
  },
  data () {
    return {
      themeMode: 'light'
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated,
      isImpersonating: state => state.isImpersonating
    }),
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      isSidebarOpen: state => state.isSidebarOpen
    })
  },
  methods: {
    ...mapActions(['openChatWabee']),
    /**
     * change language
     */
    async changeLanguage () {
      try {
        await UsersService.changeLanguage(this.user.id, this.$i18n.locale)
        UsersService.setCookie('user_language', this.$i18n.locale, 30)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    /**
     * handle open chat wabee
     */
    handleOpenChat () {
      this.openChatWabee()
    },
    /**
     * Logout
     */
    async logout () {
      try {
        await AuthService.logout()
        this.$router.push('/')
        location.reload()
      } catch (error) {
      }
    },
    async stopImpersonate () {
      await AuthService.stopImpersonate()
      window.location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>

#main-header {
  position: relative;
  z-index: 2;
  height: 86px;

  nav {
    position: relative;
    z-index: 2;
    background: #fff;
  }

  .logo {
    padding: 20px 35px;
    margin: 0;

    img {
      width: 130px;
    }
  }

  .icon-menu {
    width: 25px;
  }
}

#kt_app_header_container {
  background-color: #fff;
}

.menu-link {
  color: $color2;
  &.active {
    color: $color10;

    .icon {
      fill: $color10;
    }
  }
}

.btn-author-image {
  width: 50px;
  height: 50px;
  background: #eee;
  display: block;
}

.btn-toggle {
  font-size: 25px;
}

.svg-icon {
  color: $color1 !important;
}

.header {
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
}
</style>
